import { locationIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getProductsActiveLocations = {
  name: "getProductsActiveLocations" as const,
  input: z.object({ productIds: z.array(productIdFormat.schema) }),
  output: z.object({
    locations: z.array(
      z.object({ id: locationIdFormat.schema, name: z.string() }),
    ),
  }),
};
